import clsx from 'clsx';
import { GlowPillWithIcon, IconName } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';

type VoteButtonProps = {
    iconName: IconName;
    vote: number;
    onClick: () => void;
    disabled: boolean;
    isVoted: boolean;
};

export const VoteButton: Component<VoteButtonProps> = ({ iconName, vote, onClick, disabled, isVoted }) => {
    const hoverClassEnabled = [
        'hover:before:rounded-1.5',
        'hover:before:border-bold active:before:border-bold',
        'hover:before:border-border-brand active:before:border-border-brand',
        'hover:before:z-hoverBeforeBorder active:before:z-hoverBeforeBorder',
    ];

    const onVoteChange = (_: string, checked: boolean): void => {
        if (checked) {
            onClick();
        }
    };

    return (
        <div
            className={clsx(
                'w-full',
                'relative before:absolute',
                'pointer-events-none',
                'before:w-full before:h-full',
                !disabled && hoverClassEnabled,
            )}
        >
            <GlowPillWithIcon
                type={'radio'}
                content={{
                    id: '',
                    label: `${vote}`,
                    iconName,
                }}
                checked={isVoted}
                onChange={onVoteChange}
                className={'w-full'}
            />
        </div>
    );
};
